<template>
  <div>
    <!-- Read Dialog -->
    <WsDialog
      ref="WsDialog"
      :title="_title"
      :isCloseScrollTop="isCloseScrollTop"
      :showCardActions="showCardActions"
    >
      <template v-slot:content>
        <v-skeleton-loader v-if="isLoading" type="paragraph"></v-skeleton-loader>
        <slot v-else name="content" :modelData="item">
          <WsEasyTable
            :fields="fields"
            :modelData="item"
          />
        </slot>
      </template>
      <template v-slot:leftActions>
        <WsBtn
          v-if="deletable"
          @click="$_onReadDeleteClick()"
          minWidth="100px"
          color="deleteBtn white--text"
          :loading="isLoading"
        >刪除</WsBtn>
        <WsBtn
          v-for="(item,index) in customBtns.left"
          :key="`left${index}`"
          :color="item.color"
          item.type
          :outlined="item.outlined"
          :to="item.to"
          :loading="isLoading"
          @click="$_onCustomAction(item)"
        >
          <v-icon v-if="item.icon" left>
            {{item.icon}}
          </v-icon> 
          {{item.title}}
        </WsBtn>
      </template>
      <template v-slot:rightActions>
        <WsBtn
          v-if="editable"
          @click="$_onUpdateClick()"
          minWidth="100px"
          color="textSecondary"
          outlined
          :loading="isLoading"
        >編輯</WsBtn>
        <WsBtn
          v-for="(item,index) in customBtns.right"
          :key="`right${index}`"
          :color="item.color"
          item.type
          :outlined="item.outlined"
          :to="item.to"
          :loading="isLoading"
          @click="$_onCustomAction(item)"
        >
          <v-icon v-if="item.icon"  left>
            {{item.icon}}
          </v-icon> 
          {{item.title}}
        </WsBtn>
      </template>
    </WsDialog>
    <!-- Delete Dialog -->
    <WsAlertDialog
      title="確定要刪除嗎？"
      description="刪除後資料將無法回覆"
      ref="deleteDialog"
      @submit="$_onAlertSubmit($event)"
    />
  </div>
</template>

<script>
export default {
  data: () => ({
    item: null,
  }),
  methods: {
    $_onUpdateClick() {
      this.$emit("update", this.item);
    },
    deleteLoadingStart() {
      this.$refs.deleteDialog.startLoading();
    },
    $_onAlertSubmit($event) {
      this.$emit("delete-submit", $event);
    },
    $_onReadDeleteClick() {
      this.$refs.deleteDialog.open(this.item);
    },
    open(item) {
      this.item = item;
      this.$refs.WsDialog.open();
    },
    close() {
      this.item = null;
      this.$refs.WsDialog.close();
      this.$refs.deleteDialog.close();
    },
    $_onCustomAction(item) {
      if (item.emit) {
        this.$emit(item.emit, {value: item.value, item: this.item});
      }
    },
  },
  computed: {
    _title() {
      if (!this.item) {
        return null;
      } else {
        return this.item[this.titleKey];
      }
    },
  },
  props: {
    titleKey: String,
    fields: Object,
    deletable: {
      type: Boolean,
      default: true,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    customBtns: {
      type: Object,
      default: function (){
        return {}
      }
    },
    isCloseScrollTop: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showCardActions: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style>
</style>